import React, { useState, useEffect } from "react";
import axios from "axios";

import { Configs } from "../api";
const AddInput = () => {
  const [name, setname] = useState("");
  const [barlocation, setlocation] = useState([]);

  const [catLoc, setcatLoc] = useState("");
  const adddata = async (e) => {
    e.preventDefault();
    try {
      const result = await axios.post(Configs.categories, {
        name: name,
        locationId: catLoc,
      });

      // console.log(result);
      window.location.reload();
    } catch (error) {
      console.log(error.message);
    }
  };
  const loadLocations = async () => {
    // console.log(catLoc)
    try {
      const result = await axios.get(Configs.locations);
      console.log(result.data.location);

      if (result.data.location.length !== null) {
        setlocation(result.data.location);
      } else {
        console.log("null");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    loadLocations();
  }, []);

  return (
    <div className="container-fluid">
      <h1 className="text-center mt-5">Categories</h1>
      <form className="d-flex mt-5 mb-3 algnItm" onSubmit={adddata}>
        <input
          type="text"
          className="form-control input-styl1"
          value={name}
          onChange={(e) => setname(e.target.value)}
          required
          placeholder="Name"
        ></input>

        <select
          id="dropdown"
          value={barlocation._id}
          className="form-control input-styl"
          onChange={(e) => setcatLoc(e.target.value)}
          required
        >
          <option value="">select location</option>
          {barlocation.map((loc) => (
            <option key={loc._id} value={loc._id}>
              {loc.name}
            </option>
          ))}
        </select>

        <button className="btn btn-success">add</button>
      </form>
    </div>
  );
};

export default AddInput;
